import app from '@/app';
import templateUrl from './solution-detail.html';

/* @ngInject */
function Controller($controller, $timeout, $scope, Solution, Principal, $http, AlertService) {
	const $ctrl = this;
	
  $ctrl.currentAccount = null;
  
  Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

  $ctrl.clearUiSelect = function($event, $select) {
    $event.stopPropagation();
    $select.selected = null;
    $select.search = null;
    $ctrl.entity.budgetLimit= null;

  };

  $controller('AbstractEntityDetailController', {
		$ctrl,
		resource: Solution,
		type: 'solution'
	});

	const originalSave = $ctrl.save;
	$ctrl.save = () => {
		if ($ctrl.entity.items && $ctrl.entity.items.length > 0) {
			const seen = new Set();
			for (const item of $ctrl.entity.items) {
				const metric = item.metric ? item.metric.trim() : '';
				const muxer = (item.muxer !== undefined && item.muxer !== null) ? Number(item.muxer) : '';
				const adder = (item.adder !== undefined && item.adder !== null) ? Number(item.adder) : '';
				const key = `${metric}_${muxer}_${adder}`;
				if (seen.has(key)) {
					AlertService.error('message.solution.duplicateMetric');
					return;
				}
				seen.add(key);
			}
		}
		originalSave();
	};

	$ctrl.idgen = -1;

	$ctrl.addItem = () => $ctrl.entity.items.push({ id: --$ctrl.idgen });

	$ctrl.dirtyItems = () => {
		$timeout(() => $ctrl.setDirty($ctrl.solutionForm.items));
	};

	$ctrl.removeItem = id => {
		$ctrl.entity.items = $ctrl.entity.items.filter(it => it.id != id);
		$ctrl.dirtyItems();
		$ctrl.items = true;
	};

  $ctrl.hasStepGrade = it => {
    if(it.shoulderSolution){
		  return it.grade != it.shoulderSolution.grade;
    }
	};

	// The "recalculate cracking start year (TR age)" option only applies to
	// solutions that alter the TR — i.e. that have an item with the TR metric.
	$ctrl.altersTr = () => {
		if (!$ctrl.allMetrics || !$ctrl.entity || !$ctrl.entity.items) {
			return false;
		}
		var tr = $ctrl.allMetrics.find(m => m.name === 'tr');
		if (!tr) {
			return false;
		}
		return $ctrl.entity.items.some(it => it.metric === tr.code);
	};

  this.$onInit = function() {
    $http.get('api/solutions/solutionsList/').then(function(response) {
      $ctrl.allSolutions = response.data.filter(it => it.id != $ctrl.entity.id);
    })

    //removing icp and atr
    $ctrl.allMetrics = $ctrl.allMetrics.filter(it => it.name != 'icp' && it.name != 'atr')
  }
}

const component = {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^solutionSearch'
	},
	bindings: {
		$transition$: '<',
		allMetrics: '<',
		entity: '<'
	}
};

app.component('solutionDetail', component);
